<app-form-schema-renderer *ngIf="resolvedSchema && data"
	[property]="[]" [schema]="resolvedSchema" [data]="data" [readonly]="(canEdit$ | async) !== true"
	(emitFormSubmit)="editParticipant($event)" [formID]="participantFormID"
	(emitFormValid)="setSubmitActive($event)"
>
</app-form-schema-renderer>
<div nz-row [nzJustify]="'space-between'">
	<div nz-col>
		<div nz-row [nzGutter]="[16, 6]">
			<div nz-col>
				<app-splitbutton [elements]="[userCancelSplitButton]"></app-splitbutton>
			</div>
			<div nz-col>
				<app-splitbutton *ngIf="data"
							[elements]="[userDeleteSplitButton]"></app-splitbutton>
			</div>
		</div>
	</div>
	<div nz-col>
		<div nz-row [nzJustify]="'end'" [nzGutter]="[16, 6]">
			<div nz-col>
				<app-splitbutton *ngIf="resolvedSchema && data"
								[elements]="[userEditSplitButton]"
				>
				</app-splitbutton>
			</div>
		</div>
	</div>
</div>

<nz-modal
		[nzMaskClosable]="false"
		nzTitle="{{ 'participant.delete.modal.title' | translate:{pid: participantInfo} }}"
		(nzOnOk)="deleteUser()"
		(nzOnCancel)="closeDeleteUserModal()"
		[nzVisible]="deleteUserModalVisible"
		nzOkText="{{ 'actions.OK' | translate }}"
		nzCancelText="{{ 'actions.cancel' | translate }}"
>
	{{ 'participant.delete.modal.text' | translate:{pid: participantInfo} }}
</nz-modal>
